export const THEME_DARK_MODE = 'dark';
export const THEME_LIGHT_MODE = 'light';
